import { useSeoMeta } from '../utils/jsonLd';
import { PAGE_SEO } from '../utils/pageSeo';

/**
 * Drop-in SEO tag component. Pass `pageKey` matching a key in PAGE_SEO
 * (e.g. "stories", "about", "wall") and this will inject the canonical URL,
 * title, description, OG + Twitter meta for that page.
 *
 * Renders nothing.
 */
const PageSeoTag = ({ pageKey, overrides = {} }) => {
  const base = PAGE_SEO[pageKey] || {};
  useSeoMeta({ ...base, ...overrides });
  return null;
};

export default PageSeoTag;
